import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Header from '../../components/Header';
import Button from '../../components/Button';
import imgTimeout from '../../assets/images/timeout.png';

import { newNextAction } from '../../actions/navigation';

const strHeadLine = 'Your Session Timed Out';

const Timeout = (props) => {
  const { checkinData, navigate, params, searchParams } = props;
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  const handleButtonClick = (e) => {
    e.preventDefault();
    const { dispatch } = props;

    dispatch(newNextAction({
      key,
      workflowType: workflowType || 'text2apply',
      success: (response) => {
        const routeUrl = response.data && response.data.url;
        navigate(routeUrl);
      },
      fail: (error) => {
        navigate({
          pathname: '/results/denied',
          search: '',
          state: {
            data: error.data,
          },
        });
      },
    }));
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <div className="content">
        <img src={imgTimeout} style={{ width: 100, margin: '0 auto' }} alt="" />
        <br />
        <h1>{strHeadLine}</h1>
        <p>Please click the button below to resume signing your loan document.</p>
        <br />
        <Button
          className="btn btn-primary arrow"
          onClick={handleButtonClick}
          title="CONTINUE TO ESIGN"
        />
      </div>
    </div>
  );
};

Timeout.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(Timeout);
